import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 0CAAACF8-3D1C-4CCA-A3E4-3590CDEEC5D6
 * name ellipse
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ellipse.svg
 * tags
 * - Shape 
 */
export const EllipseIcon = createSvgIcon(<><path d="M12,4C6.5,4 2,7.58 2,12C2,16.42 6.5,20 12,20C17.5,20 22,16.42 22,12C22,7.58 17.5,4 12,4Z" /></>, 'EllipseIcon');
export default EllipseIcon